export const subscriptionActionTypes = {
    CLEAR: "CLEAR",
    STORE_SUBSCRIPTION: "STORE_SUBSCRIPTION",
    STORE_SUBSCRIPTION_PRODUCT_GROUPS: "STORE_SUBSCRIPTION_PRODUCT_GROUPS",
    STORE_SUBSCRIPTIONS: "STORE_SUBSCRIPTIONS",
    CLEAR_SUBSCRIPTION: "CLEAR_SUBSCRIPTION",
    STORE_SUBSCRIPTION_LICENSES: "STORE_SUBSCRIPTION_LICENSES",
    STORE_AVAILABLE_MIGRATION: "STORE_AVAILABLE_MIGRATION",
}